export default __webpack_public_path__ + "static/media/igpostplayer.8c836d47.png";